import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ScrollText, Loader2 } from "lucide-react";
import { PageHeader } from "@/components/common/PageHeader";
import { Panel } from "@/components/common/Panel";
import { EmptyState } from "@/components/common/EmptyState";
import { formatDate } from "@/lib/nav";

const ACTION_CLS = {
  login: "text-status-info",
  erstellt: "text-status-success",
  aktualisiert: "text-status-warning",
  gelöscht: "text-status-danger",
  freigabe: "text-status-success",
  abgelehnt: "text-status-danger",
};

export default function AuditLog() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/audit").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="audit-page">
      <PageHeader title="Audit Log" subtitle="Chronologische Aufzeichnung aller sicherheitsrelevanten Systemereignisse." />

      {items === null ? (
        <div className="flex h-40 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-fundio-gold" /></div>
      ) : items.length === 0 ? (
        <EmptyState icon={ScrollText} title="Keine Ereignisse" testid="audit-empty" />
      ) : (
        <Panel testid="audit-panel">
          <ul className="divide-y divide-fundio-border">
            {items.map((a) => (
              <li key={a.id} data-testid={`audit-row-${a.id}`} className="flex items-start gap-3 px-3 py-3">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-fundio-gold" />
                <div className="min-w-0 flex-1">
                  <p className="text-sm text-fundio-ink"><span className="font-medium">{a.user_email}</span> <span className={`font-mono text-xs uppercase ${ACTION_CLS[a.action] || "text-fundio-muted"}`}>{a.action}</span> <span className="text-fundio-faint">· {a.target}</span></p>
                  {a.detail && <p className="mt-0.5 text-xs text-fundio-muted">{a.detail}</p>}
                </div>
                <span className="shrink-0 font-mono text-[11px] text-fundio-faint">{formatDate(a.timestamp)}</span>
              </li>
            ))}
          </ul>
        </Panel>
      )}
    </div>
  );
}
